import React from 'react';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
import $, { param } from 'jquery';
//formato de cantidades
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
}

const renderTableBody = (headers, data, checkbox, openDocumentDetails, view, texArea) => {
    let body = "";
    const isOPRQ = Number($('#selectDocTypeDocumentSearch')?.val() || 0) === 1470000113;

    body = data.map((register, index) => {

        let docDate = new Date(register.DocDate);
        let docDueDate = new Date(register.DocDueDate);

        docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
        docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());
        let CreateTime = (register.CreateTime || '').toString();
        let updateTime = (register.UpdateTime || '').toString();
        let createTimeHour = '';
        let updateTimeHour = '';

        if (CreateTime.length > 0) {
            let position = CreateTime.length - 2;
            createTimeHour = CreateTime.slice(0, position) + ":" + CreateTime.slice(position, CreateTime.length)
        }
        if (updateTime.length > 0) {
            let position = updateTime.length - 2;
            updateTimeHour = updateTime.slice(0, position) + ":" + updateTime.slice(position, updateTime.length)
        }


        let input = <div>
            <textarea
                type="text"
                className=" form-control btn-outline-secondary"
                id={`txtCommentsFile` + index}
                rows="1"
                disabled={true}
                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                value={register.Remarks2 || ''} />
        </div>
        return (
            <tr key={index} style={{ color: 'black' }}>
                <td className="sticky-column" style={{ width: '5px' }}>
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2"
                        checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[9].value && <td className="font-weight-bold">{register.DocNum + 'AH' + register.DocEntry}</td>}
                {headers[0].value && <td className="text-center font-weight-bold">{isOPRQ ? register.DocNum || '' : register.DocNumOrigin && register.DocNumOrigin !== -1 ? register.DocNumOrigin : 'Sin orígen'}</td>}

                {headers[1].value && <td className="text-right font-weight-bold">{input}</td>}
                {headers[2].value && <td>{isOPRQ ? register.Sucursal : register.CardCode}</td>}
                {headers[3].value && <td><p className="NameClient">{isOPRQ ? register.ReqName || register.U_NAME || '' : register.CardName}</p></td>}
                {headers[4].value &&
                    <td className="text-right font-weight-bold">{CURRENCY + formatNumber.new(Number(register.DocTotal) === 0 || register.DocTotal <= '0' || register.DocTotal === null || isNaN(register.DocTotal) || register.DocTotal === 'undefined' || register.DocTotal === undefined || register.DocTotal === "" ? "0.00" : register.DocTotal)}</td>}
                {headers[5].value &&
                    <td className="text-center">{moment(docDueDate).format("MM-DD-YYYY")}</td>}
                {headers[6].value &&
                    <td className="text-center">{createTimeHour}</td>}
                {headers[7].value &&
                    <td className="text-right">{register.CreateDate || ''}</td>}
                {headers[8].value &&
                    <td className="text-right "> {updateTimeHour}</td>}
                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDocumentDetails({ DocEntry: register.DocEntryODRF, Status1: register.Status1, index, WstCode: register.WstCode, WtmName: register.WtmName })}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )
    }
    )
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails, view, texArea) => {
    let header = "";
    let body = "";
    const isOPRQ = Number($('#selectDocTypeDocumentSearch')?.val() || 0) === 1470000113;

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef", width: '3px' }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox"
                    onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[9].value && <td>{headers[9].title}</td>}
            {headers[0].value && <td><p className="headerTableBorrador">{isOPRQ ? 'Solicitud de Compra' : headers[0].title}</p></td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{isOPRQ ? 'Sucursal' : headers[2].title}</td>}
            {headers[3].value && <td>{isOPRQ ? 'Nombre del Solicitante' : headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td><p className="headerTableBorrador">{headers[6].title}</p></td>}
            {headers[7].value && <td><p className="headerTableBorrador">{headers[7].title}</p></td>}
            {headers[8].value && <td>{headers[8].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails, view, texArea);

    let table = "";

    table = <table id="dataTableTimbra" className="display TableBorrador" style={{ width: '100%' }}>
        <thead className="table-header" style={{ fontSize: '13px' }}>
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableBorrador = (headers, data, checkbox, openDocumentDetails, view, texArea) => {
    return renderTable(headers, data, checkbox, openDocumentDetails, view, texArea);

}
